import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CuestionariosService, CuestiposRequest } from '../services/cuestionarios.service';
import { SessionService } from '@shared/helpers/sesion.service';
@Component({
  selector: 'app-nuevo-tipo-dialog',
  templateUrl: './nuevo-tipo-dialog.component.html',
  providers: [MessageService]
})
export class NuevoTipoDialogComponent implements OnInit, OnChanges {
  @Input() displayDialog: boolean = false;
  @Input() cuestionario: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean, success?: boolean, error?: string}>();

  form: FormGroup;
  tipos: any[] = [];
  loading: boolean = false;
  tipoSeleccionado: string;

  private readonly tipoConfig = {
    '0': { tabla: 'cmtbl_propiedades', campo: 'tipo_propiedad' },
    '1': { tabla: 'cmtbl_domicilios', campo: 'tpo_domicilio' },
    '2': { tabla: 'cmtbl_empleos', campo: 'tipo_ingreso' },
    '3': { tabla: 'cmtbl_refcome', campo: 'tpo_referencia' },
    '4': { tabla: 'cmtbl_refpers', campo: 'tpo_ref' },
    '5': { tabla: 'sotbl_multpro', campo: 'tipo' }
  };

  constructor(
    private fb: FormBuilder,
    private cuestionariosService: CuestionariosService,
    private sessionService: SessionService,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      sTipo: [null, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.cargarTipos();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cuestionario'] && this.cuestionario) {
      this.cargarTipos();
    }
  }

  cargarTipos(): void {
    if (!this.cuestionario?.iTipo && this.cuestionario?.iTipo !== 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se ha seleccionado un tipo de cuestionario'
      });
      return;
    }

    const tipoKey = this.cuestionario.iTipo.toString();
    const config = this.tipoConfig[tipoKey];
    if (!config) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Tipo de cuestionario no válido'
      });
      return;
    }

    this.loading = true;
    this.cuestionariosService.getOpcionesVariables({
      sTabla: config.tabla,
      sCampo: config.campo,
      iIdioma: 0
    }).subscribe({
      next: (response) => {
        if (response.success) {
          this.tipos = response.data.map((item) => ({
            label: item.sOpcion,
            value: item.sValor
          }));
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los tipos'
          });
        }
      },
      error: (error) => {
        console.error('Error al cargar tipos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los tipos'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      // Por ahora solo cerramos el diálogo
      this.onDialogClosed();
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor seleccione un tipo'
      });
    }
  }

  guardar(): void {
    if (!this.tipoSeleccionado) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Debe seleccionar un tipo'
      });
      return;
    }

    const request: CuestiposRequest = {
      sUsuario: this.sessionService.getUserSession(),
      iAccion: 1,
      sCuest: this.cuestionario.sClaveCues,
      sTipo: this.tipoSeleccionado
    };

    this.loading = true;
    this.cuestionariosService.guardarTipoCuestionario(request).subscribe({
      next: (response) => {
        if (response.success) {
          this.messageService.add({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Tipo guardado correctamente'
          });
          this.displayDialog = false;
          this.displayDialogChange.emit(this.displayDialog);
          this.onHide.emit({ refresh: true, success: true });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message || 'Error al guardar el tipo'
          });
        }
      },
      error: (error) => {
        console.error('Error al guardar tipo:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al guardar el tipo'
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }
}   